import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SECTORS } from "../../lib/sectors";

export const SectorGrid = () => {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="bg-canvas py-28 md:py-40 scroll-mt-nav"
    >
      <div className="container-bharat">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="overline">Sector Expertise</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-navy mt-6 leading-[1.02] tracking-tight">
              Five practices.{" "}
              <span className="italic text-gold">One mandate</span> — Bharat's
              next century.
            </h2>
          </div>
          <p className="lg:col-span-5 text-graphite/70 text-base md:text-lg leading-relaxed">
            Each practice is led by domain experts who have served at the
            intersection of policy, capital and execution. Explore the
            disciplines that anchor our advisory work.
          </p>
        </div>

        <div className="hairline mb-10" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SECTORS.map((s, i) => {
            const Icon = s.Icon;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className={i === 0 ? "md:col-span-2 lg:col-span-2" : ""}
              >
                <Link
                  to={`/sectors/${s.slug}`}
                  data-testid={`sector-card-${s.slug}`}
                  className="group block relative h-full bg-white border border-graphite/10 hover:border-navy transition-all duration-500 overflow-hidden"
                >
                  <div className="relative aspect-[16/10] overflow-hidden bg-navy">
                    <img
                      src={s.image}
                      alt={s.name}
                      className="w-full h-full object-cover opacity-90 group-hover:scale-[1.04] group-hover:opacity-100 transition-all duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-navy/30 to-transparent" />
                    <div className="absolute top-5 left-5 inline-flex items-center gap-2 text-ivory">
                      <Icon size={16} className="text-gold" />
                      <span className="overline text-gold text-[0.6rem]">
                        0{i + 1}
                      </span>
                    </div>
                    <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                      <h3 className="font-serif-display text-2xl md:text-3xl text-ivory leading-tight max-w-[80%]">
                        {s.name}
                      </h3>
                      <ArrowUpRight
                        size={22}
                        className="text-gold opacity-0 group-hover:opacity-100 group-hover:-translate-y-1 transition-all duration-500"
                      />
                    </div>
                  </div>

                  <div className="p-7">
                    <p className="text-sm text-graphite/70 leading-relaxed">
                      {s.tagline}
                    </p>
                    <div className="mt-5 flex items-center justify-between">
                      <span className="text-xs text-navy underline-grow">
                        Explore practice
                      </span>
                      <span className="text-xs text-graphite/40 font-display tracking-[0.25em]">
                        {s.short.toUpperCase()}
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectorGrid;
